import './SerialTicketHero.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'

export default function SerialTicketHero() {
  const { t } = useTranslation()

  return (
    <div className="hero">
      <div className="title">{t('hero.mainTitle')}</div>
      <div className="subtitle" dangerouslySetInnerHTML={{ __html: t('hero.subtitle') }} />
    </div>
  )
}
